import type { Response } from "../types/response";

export const transformListResponse = <T>(response: Response<T>) => ({
  data: response?.data || [],
  hasNextLink: !!response?.links?.next,
  totalCount: response?.meta?.totalCount,
});